<div class="min-h-screen bg-[#f8fafc] p-4 md:p-6">
  <div class="container mx-auto px-2 md:px-4">
    <div class="flex justify-center items-center my-4 md:my-8 mt-16 md:mt-8">
      <app-page-title [titleKey]="'navigation.observations'"></app-page-title>
    </div>

    <div class="mb-4 md:mb-8">
      <app-children-selector [autoSelectFirst]="true" (studentSelected)="onStudentSelected($event)"
        (studentsLoaded)="onStudentsLoaded($event)">
      </app-children-selector>
    </div>

    <!-- Observations Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-start self-start">
      <div *ngFor="let item of observations" class="bg-white shadow-lg rounded-xl p-4 relative">
        <!-- NEW Badge -->
        <div *ngIf="item.isNew"
          class="absolute -top-3 -right-3 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full shadow-md m-x-12">
          {{ "observationComponent.new" | translate }}
        </div>

        <!-- Header -->
        <div class="flex justify-between items-center">
          <div>
            <span [class]="!item.isExpanded ? 'block truncate max-w-[250px] md:max-w-[500px]' : ''"
              class="font-bold text-[#009688]">
              {{ "observationComponent.observationLabel" | translate }}
              <span class="text-black text-sm md:text-base">{{ item.title }}</span>
            </span>
            <span class="text-[#009688] text-sm ml-2">{{
              item.date | date: "dd-MM-yyyy"
              }}</span>
          </div>
          <button (click)="toggleExpand(item)" class="bg-white rounded-full shadow-lg p-2 hover:bg-gray-50 transition"
            style="box-shadow: 0 0 10px 3px #009688">
            <svg *ngIf="!item.isExpanded" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#009688]" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
            <svg *ngIf="item.isExpanded" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#009688]" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
            </svg>
          </button>
        </div>

        <!-- Expanded Details -->
        <div *ngIf="item.isExpanded" class="mt-4 border-t pt-4 space-y-4">
          <!-- Description -->
          <p *ngIf="item.description" class="text-gray-700">
            {{ item.description }}
          </p>

          <!-- Video -->
          <div *ngIf="item.video?.path" class="mt-2">
            <iframe [src]="getSafeVideoUrl(item.video.path)" width="100%" height="315" frameborder="0" allowfullscreen
              class="rounded-lg shadow"></iframe>
          </div>

          <!-- Files -->
          <div *ngIf="item.files?.length > 0" class="mt-2">
            <h4 class="font-semibold text-gray-800">Attachments:</h4>
            <ul class="space-y-2">
              <li *ngFor="let file of item.files; let i = index" class="flex flex-col space-y-1">
                <ng-container [ngSwitch]="file.fileName.split('.').pop()?.toLowerCase()">
                  <!-- Audio -->
                  <ng-container *ngSwitchCase="'mp3'">
                    <span class="text-[#009688]">{{ "observationComponent.file" | translate }}
                      {{ i + 1 }} (MP3)</span>
                    <audio [src]="getFileUrl(file)" controls class="w-full mt-1"></audio>
                  </ng-container>
                  <!-- Image -->
                  <ng-container *ngSwitchCase="'jpg'">
                    <a [href]="getFileUrl(file)" target="_blank" download
                      class="text-[#009688] hover:underline cursor-pointer">
                      {{ "observationComponent.file" | translate }} {{ i + 1 }} (JPG)
                    </a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'jpeg'">
                    <a [href]="getFileUrl(file)" target="_blank" download
                      class="text-[#009688] hover:underline cursor-pointer">
                      {{ "observationComponent.file" | translate }} {{ i + 1 }} (JPEG)
                    </a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'png'">
                    <a [href]="getFileUrl(file)" target="_blank" download
                      class="text-[#009688] hover:underline cursor-pointer">
                      {{ "observationComponent.file" | translate }} {{ i + 1 }} (PNG)
                    </a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'gif'">
                    <a [href]="getFileUrl(file)" target="_blank" download
                      class="text-[#009688] hover:underline cursor-pointer">
                      {{ "observationComponent.file" | translate }} {{ i + 1 }} (GIF)
                    </a>
                  </ng-container>
                  <!-- PDF -->
                  <ng-container *ngSwitchCase="'pdf'">
                    <a [href]="getFileUrl(file)" target="_blank" class="text-[#009688]">
                      {{ "observationComponent.file" | translate }}
                      {{ i + 1 }} (PDF)
                    </a>
                  </ng-container>
                  <!-- Video -->
                  <ng-container *ngSwitchCase="'mp4'">
                    <video [src]="getFileUrl(file)" controls style="max-width: 320px; max-height: 240px"></video>
                  </ng-container>
                  <!-- Other -->
                  <ng-container *ngSwitchDefault>
                    <div class="flex items-center space-x-2">
                      <a [href]="getFileUrl(file)" target="_blank" class="text-[#009688]">
                        {{ "observationComponent.file" | translate }}
                        {{ i + 1 }}
                      </a>
                      <a [href]="getFileUrl(file)" download class="text-gray-500 hover:text-[#009688] transition"
                        title="Download file">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
                        </svg>
                      </a>
                    </div>
                  </ng-container>
                </ng-container>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="flex flex-wrap justify-center items-center gap-2 mt-8 mb-12">
      <button (click)="previousPage()" [disabled]="currentPage === 1"
        class="w-10 h-10 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-50">
        <svg class="w-5 h-5 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>

      <div class="flex flex-wrap justify-center items-center gap-1">
        <ng-container *ngFor="let page of getVisiblePages()">
          <span *ngIf="page === '...'" class="w-8 md:w-10 h-10 flex items-center justify-center text-gray-500">
            ...
          </span>
          <button *ngIf="page !== '...'" (click)="goToPage(+page)" [class]="
              currentPage === +page
                ? 'w-8 md:w-10 h-10 flex items-center justify-center rounded-md bg-[#009688] text-white font-bold border border-[#009688]'
                : 'w-8 md:w-10 h-10 flex items-center justify-center rounded-md bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'
            ">
            {{ page }}
          </button>
        </ng-container>
      </div>

      <button (click)="nextPage()" [disabled]="currentPage === totalPages"
        class="w-10 h-10 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-50">
        <svg class="w-5 h-5 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </div>
  </div>
</div>